import React from "react";
import styled from "styled-components";
import { moneyFormatter } from "../../../../helpers/util";
import Checkbox from "../../../common/Checkbox";

const RefundForm = ({
  amount,
  handleChange,
}) => (
  <div>
    
    <InputWrapper>
      <label className="label">
        <strong>Amount to process</strong>
      </label>
      <input
        type="number"
        name="process_amount"
        value={amount}
        onChange={handleChange}
      />

     
    </InputWrapper>
  </div>
);

export default RefundForm;

const Header = styled.h1`
  display: flex;
  padding: 0 10px;
  justify-content: space-between;
  strong {
    font-weight: 500;
  }
`;

const InputWrapper = styled.div`
  padding: 20px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #e7ebee;

  strong {
    font-weight: 500;
  }

  .label {
    display: block;
    margin-bottom: 6px;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  input {
    display: block;
    width: 100%;
    padding: 0 10px;
    border-radius: 3px;
    height: 36px;
    box-shadow: inset 0 1px 0 0 rgba(63, 63, 68, 0.05);
    border: 1px solid #c4cdd5;
    outline: none;
    font-size: inherit;
    margin-bottom: 16px;

    :focus {
      border: 2px solid #5c6ac4 !important;
    }
  }
`;
